import { specialityOptionApi } from '../api/speciality-option'

export const {
  useGetSpecialityOptionsQuery,
  useLazyGetSpecialityOptionsQuery,
  useCreateSpecialityOptionMutation,
  useUpdateSpecialityOptionMutation,
  useDeleteSpecialityOptionMutation,
} = specialityOptionApi
